import 'current-script-polyfill';

const getScriptUrl = () => {
  if (document.currentScript) {
    return new URL(document.currentScript.src);
  }
  const currentScript = document.querySelector('script[src*="main"');

  if (currentScript) {
    return new URL(currentScript.src);
  }

  return window.location;
};

// eslint-disable-next-line camelcase,no-undef
__webpack_public_path__ = (`${getScriptUrl().origin}${__webpack_public_path__}`); // NOSONAR
